var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.79 124.61"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.65 62.34c-34.31 0-62.33 28.02-62.33 62.33 0-34.31-28.02-62.33-62.33-62.33 34.31 0 62.33-28.02 62.33-62.33 0 34.31 28.02 62.33 62.33 62.33z",
    fill: "#ffff39",
    stroke: "#231f20",
    strokeWidth: 3.148,
    strokeMiterlimit: 10
  })));
}
export default __webpack_public_path__ + "d7e03ccd7efc3fbe1d3f55a87e3f8b5d.svg";
export { SvgStar as ReactComponent };